import parse from 'html-react-parser';
import React from 'react';

const decodeHtmlEntities = (htmlString) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = htmlString;
  return textarea.value;
};

export const renderTextWithActions = (htmlString, callback) => {
  const decodedText = decodeHtmlEntities(htmlString);
  const actionTagPattern = /\{action\}(.+?)\{\/action\}/g;

  const parts = decodedText.split(actionTagPattern);

  return parts.map((part, index) => {
    if (index % 2 === 1) {
      return (
        <span
          key={index}
          style={{ textDecoration: 'none', fontWeight: 700, color: '#7D54DE' }}
          onClick={(e) => callback(e)}
          className={'action-link'}
        >
          {part}
        </span>
      );
    } else {
      return <span key={index}>{parse(part)}</span>;
    }
  });
};
